<template>
  <div class="schedule-ps--container">
    <div v-for="(item, idx) in list" :key="item.id" class="shadow-card mrg-t-10">
      <div><b>Правило #{{ idx+1 }}</b></div>
      <div 
        v-if="
          !existsServiceInRule(
              item.what_set.service.category_id,
              item.what_set.service.service_id,
              item.what_set.service.modification_id
            )
        " 
        class="text-danger text-center"
      >
        Услуга не найдена. Правило не сработает! Можете его удалить
      </div>
      <div 
        v-if="!existsStaffInRule(item.what_set.staff_id)"
        class="text-danger text-center"
      >
        Сотрудник не найден. Правило не сработает! Можете его удалить
      </div>
      <div>
        <span v-if="item.start_logic.type == 'by_weekday'">
          Запускается 
          <span 
            v-if="
              item.start_logic.value == 1 || 
              item.start_logic.value == 2 || 
              item.start_logic.value == 4 
            "
          >
            <b>каждый</b>
          </span>
          <span
            v-if="
              item.start_logic.value == 5 || 
              item.start_logic.value == 6 || 
              item.start_logic.value == 3
            "
          >
            <b>каждую</b>
          </span>
          <span v-if="item.start_logic.value == 0">
            <b>каждое</b>
          </span>
          <span v-if="item.start_logic.value == 1"><b> понедельник</b></span>
          <span v-if="item.start_logic.value == 2"><b> вторник</b></span>
          <span v-if="item.start_logic.value == 3"><b> среду</b></span>
          <span v-if="item.start_logic.value == 4"><b> четверг</b></span>
          <span v-if="item.start_logic.value == 5"><b> пятницу</b></span>
          <span v-if="item.start_logic.value == 6"><b> субботу</b></span>
          <span v-if="item.start_logic.value == 0"><b> воскресенье</b></span>
        </span>
        <span v-if="item.start_logic.type == 'before_end_month'">
          Запускается <b>за {{ item.start_logic.value }} дней до конца месяца</b>
        </span>
      </div>
      <div v-if="
        existsServiceInRule(
            item.what_set.service.category_id,
            item.what_set.service.service_id,
            item.what_set.service.modification_id
          )
      ">
        Создает запись на услугу: <b>{{ 
          getServiceName(
            item.what_set.service.category_id,
            item.what_set.service.service_id,
            item.what_set.service.modification_id
          ) 
        }}</b>
      </div>
      <div 
        v-if="existsStaffInRule(item.what_set.staff_id)"
      >
        На сотрудника: <b>{{ getStaffName(item.what_set.staff_id) }}</b>
      </div>
      <div>
        Время: <b>{{ minuteToTime(item.what_set.enroll_time) }}</b>
      </div>
      <div>
        Кол-во участников: <b>{{ item.what_set.group_setting.participants_count }}</b>
      </div>
      <div>
        Показывать кол-во занятых и свободных мест: 
          <b>{{ item.what_set.group_setting.show_seats_left === "true" ? 'Да' : 'Нет' }}</b>
      </div>
      <div>
        Отправлять уведомления новым: 
          <b>{{ item.what_set.group_setting.notifications_new === "true" ? 'Да' : 'Нет' }}</b>
      </div>
      <div>
        Отправлять автонапоминания: 
          <b>{{ item.what_set.remind_before_setting === "true" ? 'Да' : 'Нет' }}</b>
      </div>
      <div class="mrg-t-5">
        <div>Дни недели в которые будет установлено расписание:</div>
        <div
          v-for="(week, idx) in item.what_set.where_to_set.data" :key="idx"
        >
          {{ idx + 1 }}-я неделя: 
          <span v-for="(day, idx) in week" :key="idx">
            <b>
            <span v-if="day == 1"> Пн</span>
            <span v-if="day == 2"> Вт</span>
            <span v-if="day == 3"> Ср</span>
            <span v-if="day == 4"> Чт</span>
            <span v-if="day == 5"> Пт</span>
            <span v-if="day == 6"> Сб</span>
            <span v-if="day == 0"> Вс</span>
            </b>
          </span>
        </div>
      </div>
      <div class="mrg-t-5 text-right">
        <div @click="deletePlanner(item.id)" class="btn-badge btn-danger">Удалить правило</div>
      </div>

    </div>

    <div v-if="showCreateButton" class="mrg-t-15 text-center">
      <div @click="createRule" class="btn btn-sm btn-info">
        <f-awesome icon="plus"></f-awesome>
        Создать новое правило
      </div>
    </div>
    <div class="shadow-card mrg-t-10" v-show="!showCreateButton">
      <div class="alert alert-sm alert-info">
      Обратите внимание! В момент, когда будет срабатывать планировщик для создания групповых записей, 
      у соответствующих сотрудников должен быть проставлен график работы, иначе групповые мероприятия не
      будут созданы. Для проставления графика работы вы так же можете использовать планировщик 
      (сначала всегда отрабатывает планировщик графика работы сотрудников, 
      а потом уже планировщик групповых записей)
    </div>
      <div class="text-center text-bold mrg-b-10 mrg-t-10">Параметры нового правила</div>
      <div class="input-block">
        <label for="newPlanner_start_logic_type">Режим, когда будет применяться правило</label>
        <select
            id="newPlanner_start_logic_type"
            v-model="newPlanner.start_logic.type"
        >
          <option value="by_weekday">В определенный день недели</option>
          <option value="before_end_month">За выбранное кол-во дней до конца месяца</option>
        </select>
      </div>

      <div v-if="newPlanner.start_logic.type == 'by_weekday'" class="input-block">
        <label for="newPlanner_start_logic_value">
          Выберите день недели, когда будет применяться правило
        </label>
        <select
            v-model="newPlanner.start_logic.value"
        >
          <option value="1">Понедельник</option>
          <option value="2">Вторник</option>
          <option value="3">Среда</option>
          <option value="4">Четверг</option>
          <option value="5">Пятница</option>
          <option value="6">Суббота</option>
          <option value="0">Воскресенье</option>
        </select>
      </div>

      <div v-if="newPlanner.start_logic.type == 'before_end_month'" class="input-block">
        <label for="newPlanner_start_logic_value">
          Выберите за сколько дней до конца месяца применять правило
        </label>
        <select
            v-model="newPlanner.start_logic.value"
        >
          <option value="5">За 5 дней</option>
          <option value="10">За 10 дней</option>
          <option value="15">За 15 дней</option>
        </select>
      </div>

      <div v-if="newPlanner.start_logic.value !== ''" class="input-block">
        <label for="newPlanner_selectedStaffId">
          Выберите сотрудника
        </label>
        <select
            v-model="selectedStaffId"
        >
          <option v-for="item in staffListCanGroup" :key="item.id" :value="item.id">
            {{ item.name }}
          </option>
        </select>
      </div>

      <div v-if="selectedStaffId > 0" class="input-block">
        <label for="newPlanner_selectedCategoryId">
          Выберите категорию услуг
        </label>
        <select
            v-model="selectedCategoryId"
        >
          <option v-for="item in categoriesComputed" :key="item.id" :value="item.id">
            {{ item.name }}
          </option>
        </select>
      </div>


      <div v-if="selectedCategoryId !== ''" class="input-block">
        <label for="newPlanner_selectedServiceId">
          Выберите услугу (подкатегорию)
        </label>
        <select
            v-model="selectedServiceId"
        >
          <option v-for="item in servicesComputed" :key="item.id" :value="item.id">
            {{ item.name }}
          </option>
        </select>
      </div>


      <div v-if="selectedSubcat === true" class="input-block">
        <label for="newPlanner_selectedModificationId">
          Выберите модификацию
        </label>
        <select
            v-model="selectedModificationId"
        >
          <option v-for="item in modificationsComputed" :key="item.id" :value="item.id">
            {{ item.name }}
          </option>
        </select>
      </div>

      <div v-if="selectedServiceValidate">
        <div class="input-block">
          <label for="groupSetting_participants_count">
            Максимальное кол-во участников в групповой записи
          </label
          >
          <select 
            v-model="newPlanner.what_set.group_setting.participants_count" 
            id="groupSetting_participants_count"
          >
            <option 
              v-for="(item, index) in participantsOptionsComputed" 
              :key="index" 
              :value="item"
            >
              {{ item }}
            </option>
          </select>
        </div>
        <div class="input-block">
          <label for="groupSetting_show_seats_left">
            <input
                type="checkbox"
                v-model="newPlanner.what_set.group_setting.show_seats_left"
                id="groupSetting_show_seats_left"
            />
            Показывать кол-во занятых и свободных мест клиенту при онлайн записи
          </label>
        </div>
        <div class="input-block">
          <label for="groupSetting_notifications_new">
            <input
                type="checkbox"
                v-model="newPlanner.what_set.group_setting.notifications_new"
                id="groupSetting_notifications_new"
            />
            Отправлять <span class="text-bold">уведомления</span> 
            новым клиентам о записи согласно настройкам
          </label>
          <div class="hint">
            Данная настройка перекрывает стандартные настройки уведомлений (раздел Настройки -> Уведомления) 
            для большей гибкости, 
            т.к для групповой записи может не понадобиться отправка уведомлений.
          </div>
        </div>
        <div v-if="remainingSetting > 0" class="input-block">
          <label for="groupSetting_remind_before_setting">
            <input
                type="checkbox"
                v-model="newPlanner.what_set.remind_before_setting"
                id="groupSetting_remind_before_setting"
            />
            Отправлять <span class="text-bold">автонапоминания</span> 
            клиентам согласно настройкам
          </label>
          <div class="hint">
            У вас включены автонапоминания в настройках. Но вы можете не выбирать данную галочку и 
            тогда у созданных планировщиком записей автонапоминания будут в режиме "Не напоминать"
          </div>
        </div>
      </div>

      <div v-if="selectedServiceValidate" class="mrg-t-15">
        <div>Выберите время групповой записи</div>
        <div class="enroll-time--flex mrg-t-5">
          <div class="input-block">
            <label>Часы</label>
            <select v-model="newPlanner.what_set.enroll_time.hour">
              <option
                v-for="item in hourOptions"
                :key="item.value"
                v-bind:value="item.value"
                >{{ item.time }}</option>
            </select>
          </div>
          <div>
            <span>:</span>
          </div>
          <div class="input-block">
            <label>Минуты</label>
            <select v-model="newPlanner.what_set.enroll_time.minute">
              <option
                v-for="item in minuteOptions"
                :key="item.value"
                v-bind:value="item.value"
              >{{ item.time }}</option>
            </select>
          </div>
        </div>
      </div>


      <div v-if="selectedServiceValidate" class="mrg-t-15">
        <div class="mrg-b-10">
          Дни недели и на сколько недель вперед будет проставлено указанное расписание,
          где "1-я неделя" - это неделя применения правила
        </div>
        <div v-for="(item, idx) in newPlanner.what_set.where_to_set.data" :key="idx">
          <div class="mrg-t-10">{{ idx +1 }} - я неделя</div>
          <weekday-checker
            @emitComponent="setWeekdayChecker(idx, $event)"
            class="mrg-t-5"
          ></weekday-checker>
        </div>
        <div class="mrg-t-10">
          <div @click="addWeek" class="btn-badge btn-info mrg-t-5">
            <f-awesome icon="plus"></f-awesome>
            Добавить неделю
          </div>
          <div @click="deleteLastWeek" class="btn-badge btn-danger mrg-t-5">
            <f-awesome icon="times"></f-awesome>
            Убрать последнюю
          </div>
        </div>
      </div>

      <div class="mrg-t-20 text-center">
        <div 
          @click="createPlanner"
          v-if="newPlanner.what_set.where_to_set.data[0].length > 0" 
          class="btn btn-sm btn-success mrg-t-5"
        >
          Сохранить правило
        </div>
        <div @click="cancelCreateRule" class="btn btn-sm btn-danger mrg-t-5">Отменить создание</div>
      </div>
      

    </div>

    <popup
      :closeButton="deletePlannerPopup.closeButton"
      :actionButton="deletePlannerPopup.actionButton"
      :actionClass="deletePlannerPopup.actionClass"
      :show="deletePlannerPopup.show"
      @closePopup="closeDeletePlannerPopup"
      @actionPopup="deletePlannerSubmit"
    >
      <div slot="header">Подтвердить удаление?</div>
      <div slot="body">
        Правило будет удалено без возможности восстановления
      </div>
    </popup>


  </div>
</template>

<script>
import Popup from "@/components/Popup";
import WeekdayChecker from '../../WeekdayChecker.vue';
import Formatter from "../../libraries/Formatter";
import scheduleRepository from "../../../repositories/schedule";
import configRepository from "../../../repositories/config";

const formatter = new Formatter();

export default {
  name: "SchedulePlannerGroup",
  components: {WeekdayChecker, Popup  },
  data() {
    return {
      list: [],

      remainingSetting: 0,
      showCreateButton: true,
      selectedStaffId: 0,
      selectedCategoryId: '',
      selectedServiceId: '',
      selectedModificationId: '',
      newPlanner: {
        start_logic: {
          type: '',
          value: ''
        },
        what_set: {
          remind_before_setting: false,
          group_setting: {
            participants_count: 2,
            show_seats_left: false,
            notifications_new: false
          },
         enroll_time: {
          hour: '',
          minute: ''
         },
          where_to_set: {
            type: 'by_week',
            data: [
              []
            ]
          }
        }
      },

      deletePlannerPopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Подтвердить",
        actionClass: "btn-success"
      },
      deletedPlannerId: 0,
    };
  },
  props: {
    show: Boolean,
    staffList: Array,
    servicesList: Array
  },
  watch: {
    selectedServiceId(){
      this.selectedModificationId = '';
    },
    selectedCategoryId: function(){
      this.selectedServiceId = '';
      this.selectedModificationId = '';
    },
    selectedStaffId: function(){
      this.selectedCategoryId = '';
      this.selectedServiceId = '';
      this.selectedModificationId = '';
    },
    newPlanner: {
      handler: function(val) {
        if(val.start_logic.type === 'by_weekday'){
          if(
            val.start_logic.value == 10 ||
            val.start_logic.value == 15
          ){
            this.newPlanner.start_logic.value = '';
          }
        }else if(val.start_logic.type === 'before_end_month'){
          if(
            val.start_logic.value == 0 ||
            val.start_logic.value == 1 ||
            val.start_logic.value == 2 ||
            val.start_logic.value == 3 ||
            val.start_logic.value == 4 ||
            val.start_logic.value == 6
          ){
            this.newPlanner.start_logic.value = '';
          }
        }
        
      },
      deep: true
    },
  },
  computed: {
    hourOptions(){
      let result = [];
      for (let i = 0; i <= 23; i++) {
        let obj = {};
        obj.value = i;
        obj.time = i;
        result.push(obj);
      }
      return result;
    },
    minuteOptions(){
      let result = [];
      for (let i = 0; i <= 55; i = i + 5) {
        let obj = {};
        obj.value = i;
        obj.time = i;
        result.push(obj);
      }
      return result;
    },
    participantsOptionsComputed(){
      let result = [];
      for(let i = 2; i <= 100; i++){
        result[result.length] = i;
      }
      return result;
    },
    staffListCanGroup(){
      let result = [];
      for(let key in this.staffList){
        let existsGroup = false;

        if(
          this.staffList[key].staffToServices && 
          this.staffList[key].staffToServices.length > 0
        ){
          for(let sts in this.staffList[key].staffToServices){
            if(
              this.staffList[key].staffToServices[sts].services &&
              this.staffList[key].staffToServices[sts].services.is_group == 1
            ){
              existsGroup = true;
              continue;
            }

            if(
              this.staffList[key].staffToServices[sts].modification &&
              this.staffList[key].staffToServices[sts].modification.is_group == 1
            ){
              existsGroup = true;
              continue;
            }
          }
        }

        if(existsGroup){
          result.push(this.staffList[key]);
        }

      }
      return result;
    },
    categoriesComputed(){
      let result = [];
      let categoryIds = [];
      if(this.selectedStaffId > 0){
        for(let key in this.staffList){
          if(+this.staffList[key].id === +this.selectedStaffId){
            if(
              this.staffList[key].staffToServices && 
              this.staffList[key].staffToServices.length > 0
            ){
              for(let sts in this.staffList[key].staffToServices){
                if(
                  this.staffList[key].staffToServices[sts].services &&
                  this.staffList[key].staffToServices[sts].services.is_group == 1
                ){
                  if(!categoryIds.includes(this.staffList[key].staffToServices[sts].services.categoryData.id)){
                    categoryIds[categoryIds.length] = this.staffList[key].staffToServices[sts].services.categoryData.id;
                  }
                  continue;
                }

                if(
                  this.staffList[key].staffToServices[sts].modification &&
                  this.staffList[key].staffToServices[sts].modification.is_group == 1
                ){
                  if(!categoryIds.includes(this.staffList[key].staffToServices[sts].services.categoryData.id)){
                    categoryIds[categoryIds.length] = this.staffList[key].staffToServices[sts].services.categoryData.id;
                  }
                  continue;
                }
              }
            }
          }
        }
      }
      if(categoryIds.length){
        for(let catId in categoryIds){
          for(let key in this.servicesList){
            if(+this.servicesList[key].id === +categoryIds[catId]){
              let obj = {
                id: this.servicesList[key].id,
                name: this.servicesList[key].name,
              };
              result.push(obj);
            }
          }
        }
      }
      return result;
    },
    servicesComputed(){
      let result = [];
      let serviceIds = [];
      if(this.selectedCategoryId !== ''){
        for(let key in this.categoriesComputed){
          for(let sl in this.servicesList){
            if(+this.selectedCategoryId === +this.servicesList[sl].id){
              if(this.servicesList[sl].services.length > 0){
                for(let serv in this.servicesList[sl].services){
                  if(+this.servicesList[sl].services[serv].is_group === 1){
                    if(!serviceIds.includes(+this.servicesList[sl].services[serv].id)){
                      serviceIds[serviceIds.length] = +this.servicesList[sl].services[serv].id;
                    }
                  }

                  if(
                    +this.servicesList[sl].services[serv].subcategory === 1 && 
                    this.servicesList[sl].services[serv].modification.length > 0
                  ){
                    for(let subcat in this.servicesList[sl].services[serv].modification){
                      if(+this.servicesList[sl].services[serv].modification[subcat].is_group === 1){
                        if(!serviceIds.includes(+this.servicesList[sl].services[serv].id)){
                          serviceIds[serviceIds.length] = +this.servicesList[sl].services[serv].id;
                        }
                        
                      }
                    }
                  }

                }
              }
            }
          }
        }
      }

      if(serviceIds.length > 0){
        for(let si in serviceIds){
          for(let sl in this.servicesList){
            if(this.servicesList[sl].services.length > 0){
              for(let serv in this.servicesList[sl].services){
                if(+this.servicesList[sl].services[serv].id === +serviceIds[si]){
                  let obj = {
                    id: this.servicesList[sl].services[serv].id,
                    name: this.servicesList[sl].services[serv].name
                  };
                  result.push(obj);
                }
              }
            }
          }
        }
      }
      return result;
    },
    selectedSubcat(){
      let result = false;
      if(this.selectedServiceId !== ''){
        for(let sl in this.servicesList){
          for(let serv in this.servicesList[sl].services){
            if(
              +this.servicesList[sl].services[serv].id === +this.selectedServiceId && 
              +this.servicesList[sl].services[serv].subcategory === 1 && 
              this.servicesList[sl].services[serv].modification.length > 0
            ){
              result = true;
              break;
            }
          }
        }
      }
      return result;
    },
    modificationsComputed(){
      let result = [];
      let subcatIds = [];
      if(this.selectedSubcat){
        for(let sl in this.servicesList){
          for(let serv in this.servicesList[sl].services){
            if(
              +this.servicesList[sl].services[serv].id === +this.selectedServiceId && 
              +this.servicesList[sl].services[serv].subcategory === 1 && 
              this.servicesList[sl].services[serv].modification.length > 0
            ){
              for(let subcat in this.servicesList[sl].services[serv].modification){
                if(!subcatIds.includes(+this.servicesList[sl].services[serv].modification[subcat].id)){
                  subcatIds[subcatIds.length] = +this.servicesList[sl].services[serv].modification[subcat].id;
                }
              }
            }
          }
        }
      }

      if(subcatIds.length){
        for(let si in subcatIds){
          for(let sl in this.servicesList){
            if(this.servicesList[sl].services.length > 0){
              for(let serv in this.servicesList[sl].services){
                for(let subcat in this.servicesList[sl].services[serv].modification){
                  if(+this.servicesList[sl].services[serv].modification[subcat].id === +subcatIds[si]){
                    let obj = {
                      id: this.servicesList[sl].services[serv].modification[subcat].id,
                      name: this.servicesList[sl].services[serv].modification[subcat].name
                    };
                    result.push(obj);
                  }
                }
              }
            }
          }
        }
      }
      return result;
    },
    selectedServiceValidate(){
      let result = false;
      if(this.selectedSubcat){
        if(this.selectedModificationId !== ''){
          result = true;
        }
      }else{
        if(this.selectedServiceId !== ''){
          result = true;
        }
      }
      return result;
    }
  },
  methods: {
    deletePlannerSubmit(){
      scheduleRepository.deletePlanner({ id: this.deletedPlannerId }).then(() => {
        this.$store.dispatch("addNotification", {
          text: 'Успешно',
          time: 3,
          color: "success"
        });
        this.closeDeletePlannerPopup();
        this.getList();
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    closeDeletePlannerPopup(){
      this.deletePlannerPopup.show = false;
    },
    deletePlanner(plannerId){
      this.deletedPlannerId = plannerId;
      this.deletePlannerPopup.show = true;
    },
    minuteToTime(minutes){
      return formatter.minuteToTime(minutes);
    },
    existsServiceInRule(catId, servId, modifId){
      let result = false;
      for(let key in this.servicesList){
        if(+this.servicesList[key].id === +catId){
          for(let serv in this.servicesList[key].services){
            if(
              +this.servicesList[key].services[serv].id === +servId
            ){
              if(+this.servicesList[key].services[serv].subcategory === 1){
                if(modifId !== ''){
                  for(let modif in this.servicesList[key].services[serv].modification){
                    if(
                      +this.servicesList[key].services[serv].modification[modif].id === +modifId
                    ){
                      result = true;
                    }
                  }
                }
              }else{
                result = true;
              }
            }
          }
        }
      }
      return result;
    },
    getServiceName(catId, servId, modifId){
      let result = '';
      for(let key in this.servicesList){
        if(+this.servicesList[key].id === +catId){
          for(let serv in this.servicesList[key].services){
            if(
              +this.servicesList[key].services[serv].id === +servId
            ){
              if(+this.servicesList[key].services[serv].subcategory === 1){
                if(modifId !== ''){
                  for(let modif in this.servicesList[key].services[serv].modification){
                    if(
                      +this.servicesList[key].services[serv].modification[modif].id === +modifId
                    ){
                      result = '(' +this.servicesList[key].name +' -> ' + 
                        this.servicesList[key].services[serv].name + ') ' + 
                        this.servicesList[key].services[serv].modification[modif].name;
                    }
                  }
                }
              }else{
                result = '(' +this.servicesList[key].name + ') ' + 
                        this.servicesList[key].services[serv].name;
              }
            }
          }
        }
      }
      return result;
    },
    existsStaffInRule(id){
      let result = false;
      for(let key in this.staffList){
        if(+this.staffList[key].id === +id){
          result = true;
        }
      }
      return result;
    },
    getStaffName(id){
      for(let key in this.staffList){
        if(+this.staffList[key].id === +id){
          return this.staffList[key].name;
        }
      }
    },
    getRemainingConfig(){
      configRepository.getByName({ name: 'remind_before_setting' }).then(resp => {
        this.remainingSetting = resp.data.result;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    createPlanner(){
      if(
        this.newPlanner.what_set.enroll_time.hour === '' || 
        this.newPlanner.what_set.enroll_time.minute === ''
      ){
        this.$store.dispatch("addNotification", {
          text: 'Не выбрано время групповой записи',
          time: 3,
          color: "danger"
        });
        return false;
      }

      let data = {
        place: 'group',
        start_logic: {
          type: this.newPlanner.start_logic.type,
          value: this.newPlanner.start_logic.value
        },
        what_set: {
          service: {
            category_id: this.selectedCategoryId,
            service_id: this.selectedServiceId,
            modification_id: this.selectedModificationId
          },
          staff_id: this.selectedStaffId,
          enroll_time: formatter.hourMinuteToMinute(
              this.newPlanner.what_set.enroll_time.hour,
              this.newPlanner.what_set.enroll_time.minute
          ),
          remind_before_setting: this.newPlanner.what_set.remind_before_setting,
          group_setting: {
            participants_count: this.newPlanner.what_set.group_setting.participants_count,
            show_seats_left: this.newPlanner.what_set.group_setting.show_seats_left,
            notifications_new: this.newPlanner.what_set.group_setting.notifications_new,
          },
          where_to_set: {
            type: this.newPlanner.what_set.where_to_set.type,
            data: []
          }
        }
      };

      let whereToSetData = [];
      for (let key in this.newPlanner.what_set.where_to_set.data){
        if (this.newPlanner.what_set.where_to_set.data[key].length) {
          whereToSetData[key] = [];
        }
        for(let keyWeek in this.newPlanner.what_set.where_to_set.data[key]){
          whereToSetData[key][whereToSetData[key].length] = this.newPlanner.what_set.where_to_set.data[key][keyWeek];
          // formData.append(
          //   'what_set[where_to_set][data][' +key +'][]',
          //   this.newPlanner.what_set.where_to_set.data[key][keyWeek]
          // );
        }
      }
      data.what_set.where_to_set.data = whereToSetData;

      scheduleRepository.setPlanner(data).then(resp => {
        if(resp.data.result === 'ok'){
          this.cancelCreateRule();
          this.getList();
        }
        this.$store.dispatch("addNotification", {
          text: 'Успешно',
          time: 3,
          color: "success"
        });
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    getList(){
      scheduleRepository.getPlanner({ place: 'group' }).then(resp => {
        this.list = resp.data;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    addWeek(){
      if(this.newPlanner.what_set.where_to_set.data.length >= 10){
        this.$store.dispatch("addNotification", {
          text: 'Максимальное кол-во недель - 10',
          time: 3,
          color: "danger"
        });
        return false;
      }
      this.newPlanner.what_set.where_to_set.data.push([]);
    },
    deleteLastWeek(){
      if(this.newPlanner.what_set.where_to_set.data.length <= 1){
        this.$store.dispatch("addNotification", {
          text: 'Нельзя убрать все недели',
          time: 3,
          color: "danger"
        });
        return false;
      }
      this.newPlanner.what_set.where_to_set.data.splice(
        this.newPlanner.what_set.where_to_set.data.length - 1,
        1
      );
    },
    setWeekdayChecker(idx, val){
      for(let key in this.newPlanner.what_set.where_to_set.data){
        if(+key === +idx){
          //this.newPlanner.what_set.where_to_set[key]
          this.$set(this.newPlanner.what_set.where_to_set.data, key, val);
        }
      }
    },
    resetPlanner(){
      this.selectedStaffId = 0;
      this.selectedCategoryId = '';
      this.selectedServiceId = '';
      this.selectedModificationId = '';
      this.newPlanner = {
        start_logic: {
          type: '',
          value: ''
        },
        what_set: {
          remind_before_setting: false,
          group_setting: {
            participants_count: 2,
            show_seats_left: 0,
            notifications_new: 0,
          },
         enroll_time: {
          hour: '',
          minute: ''
         },
          where_to_set: {
            type: 'by_week',
            data: [
              []
            ]
          }
        }
      };
    },
    cancelCreateRule(){
      this.showCreateButton = true;
      this.resetPlanner();
    },
    createRule(){
      this.showCreateButton = false;
    },
  },
  created() {
    this.getList();
    this.getRemainingConfig();
  },
  mounted() {
    
  }
};
</script>

<style scoped lang="less">
.enroll-time--flex {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  flex-direction: row;

  & > div:nth-of-type(1) {
    width: 45%;
  }
  & > div:nth-of-type(2) {
    text-align: center;
    line-height: 60px;
    width: 2%;
  }
  & > div:nth-of-type(3) {
    width: 45%;
  }
}
</style>
